import React, { useEffect, useState } from "react";
import moment from "moment";
import { Button, Typography } from "@mui/material";
import NumberFormat from "react-number-format";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";

import {
  CustomButton,
  DefaultLoader,
  ButtonWrapper,
  AlertInfo,
  Alert,
} from "../../components";
import { icons, images } from "../../constants";
import { Container, Row } from "./styles";
import {
  getWithdrawalResult,
  resetCategorySaving,
  resetGeneralSaving,
  resetMaxAmount,
} from "../redux/action";
import useModal from "../../utils/hooks/useModal";
import TransactionTimeoutAlert from "../../components/TransactionTimeoutAlert";
import { convertSecondsToMinutes } from "../../utils/functions/timeFormat";
import "../switching/style.success.scss";
import { sendFundsCode } from "../fundSelection/redux/action";
import FnzTimeoutPopup from "../../components/FnzTimeoutPopup";

const DuplicateTransaction = props => {
  const {
    history,
    // sendFundsCode,
    // resetMaxAmount,
    // resetCategorySaving,
    // resetGeneralSaving,
    // getWithdrawalResult,
  } = props;

  // const dateTime = moment().utcOffset("+0800");
  const [disabled, setDisabled] = useState(false);
  /* const {
    payload,
    duplicateTransactionDetails,
    validationToken,
    validationTtl,
  } = history.location?.state || {}; */

  // const { refNo = "", date, time, amount = 0, transactionId = "" } =
  //   duplicateTransactionDetails || {};

  // const durationInMinutes = convertSecondsToMinutes(validationTtl);

  /* const {
    open: isTrxTimeoutModalOpen,
    modalOpen: openTrxTimeoutModal,
    modalClose: closeTrxTimeoutModal,
  } = useModal();

  const {
    open: isFnzTimeoutModalOpen,
    modalOpen: openFnzTimeoutModal,
    modalClose: closeFnzTimeoutModal,
  } = useModal();

  const [apiError, setApiError] = useState({
    message: "",
    isError: false,
  }); */

  // useEffect(() => {
  //   window.eventManager.on("WITHDRAWAL_SUCCESS", res => {
  //     resetCategorySaving();
  //     resetGeneralSaving();
  //     resetMaxAmount();
  //     sendFundsCode([]);
  //     getWithdrawalResult(res);
  //     history.push("/make-withdrawal/success");
  //   });

  //   window.eventManager.on("WITHDRAWAL_ERROR", res => {
  //     if (res) {
  //       setApiError(prev => ({ ...prev, message: res.message, isError: true }));
  //     }
  //     resetMaxAmount();
  //     setDisabled(false);
  //   });

  //   window.eventManager.on("WITHDRAWAL_PIN_ERROR", () => {
  //     setApiError(prev => ({
  //       ...prev,
  //       message: "Please try again",
  //       isError: true,
  //     }));
  //     setDisabled(false);
  //   });
  //   window.eventManager.on("WITHDRAWAL_PIN_CANCEL", () => {
  //     setDisabled(false);
  //   });
  //   window.eventManager.on("WITHDRAWAL_PIN_FAILED", () => {
  //     setDisabled(false);
  //   });
  //   window.eventManager.on("WITHDRAWAL_LOCK_FAILED", () => {
  //     setDisabled(false);
  //   });

  //   window.eventManager.on("WITHDRAWAL_PENDING", data => {
  //     /**
  //      * @remark see comment in file src/pages/withdrawal/pending.js on line 36
  //      */
  //     history.push("/make-withdrawal/pending", data);
  //   });

  //   // listen for transaction timeout event from native and show timeout alert with data from native
  //   window.eventManager.on("TRANSACTION_TIMEOUT", () => {
  //     setDisabled(true);
  //     openTrxTimeoutModal();
  //   });

  //   window.eventManager.on("FNZ_TIMEOUT", () => {
  //     setDisabled(true);
  //     openFnzTimeoutModal();
  //   });

  //   return () => {
  //     window.eventManager.clearAllEvents();
  //   };
  // }, []);

  /* const handleContinue = () => {
    window.verifyUser({
      api: "call",
      event: "verifyUser",
      payload: { ...payload, validationToken },
    });
  }; */

  const redirectToDashboard = () => {
    history.push("/dashboard");
  };

  /* const handleTrxTimeoutRedirect = () => {
    closeTrxTimeoutModal();
    history.push("/dashboard");
  };

  const handleCloseFnzTimeoutModal = () => {
    closeFnzTimeoutModal();
    history.push("/transaction");
  }; */

  return (
    <Container>
      {/* <Alert
        title="Something went wrong"
        description={apiError.message}
        isOpen={apiError.isError}
        isCancel={false}
        handleAction={() => setApiError(prev => ({ ...prev, isError: false }))}
      />
      <TransactionTimeoutAlert
        isOpen={isTrxTimeoutModalOpen}
        handleClose={handleTrxTimeoutRedirect}
        handleRedirectToDashboard={handleTrxTimeoutRedirect}
      />
      <FnzTimeoutPopup
        isOpen={isFnzTimeoutModalOpen}
        handleClose={handleCloseFnzTimeoutModal}
        handleRedirectToTransactionHistory={handleCloseFnzTimeoutModal}
      /> */}

      <div className="l-success">
        <img src={images.principalLogo} alt="principal-logo" />

        <h2 className="l-success__title">Possible Duplicate Transaction</h2>
        <p className="l-success__desc">
          It looks like you made a same transaction in the last 10 minutes, this
          transaction is rejected.
        </p>
        {/* <div className="l-success__separator" />
        <div className="l-success__summary">
          <p>
            <span>Date</span>
            <span>
              {moment(date)
                .utcOffset("+0800")
                .format("DD MMM YYYY")}
            </span>
          </p>
          <p>
            <span>Time</span>
            <span>
              {moment(time)
                .utcOffset("+0800")
                .format("hh:mm:ss A")}
            </span>
          </p>
          <p>
            <span>Transaction ID</span>
            <span>{transactionId}</span>
          </p>
          <p>
            <span>Reference No.</span>
            <span style={{ textAlign: "right" }}>{refNo}</span>
          </p>
          <h3>
            <span>Total:</span>
            <span>
              RM{" "}
              <NumberFormat
                value={amount}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </span>
          </h3>
        </div>
        <div className="l-success__note">
          <img src={icons.infoPrimary} alt="Info" />
          <p>
            Your transaction may take up to 7 business days to complete. Final
            value will follow the NAV on the processing day. Any applicable fees
            will be shown after processing.
          </p>
        </div> */}
        <ButtonWrapper
          style={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingInline: 0,
            gap: "1rem",
          }}
        >
          <CustomButton
            text="Ok"
            variant="contained"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={redirectToDashboard}
            disabled={disabled}
          />
        </ButtonWrapper>
      </div>
    </Container>
  );
};

const withConnect = connect(
  state => ({}),
  {
    // sendFundsCode,
    // resetMaxAmount,
    // resetCategorySaving,
    // resetGeneralSaving,
    // getWithdrawalResult,
  }
);

export default compose(
  withRouter,
  withConnect
)(DuplicateTransaction);
